import React, { useState, useRef, useEffect } from "react";
import cx from "classnames";
import ReactSVG from "react-svg";
import useDebounce from "../../../../custom-hooks/useDebounce";
import SmartPortal from "../SmartPortal";

const HistoryHeader = props => {
    const { t, filters, selectedFilter, onFilterSelect, onRefresh, onSearchChange } = props;

    const [isDropdownOpen, setIsDropdownOpen] = useState(false); // Dropdown open state
    const [query, setQuery] = useState("");

    const dropdownRef = useRef(null);

    const toggleDropdown = () => {
        setIsDropdownOpen(prevState => !prevState);
    };

    const handleFilterSelect = (filterCode, event) => {
        setIsDropdownOpen(false);
        if (onFilterSelect && typeof onFilterSelect === "function") {
            onFilterSelect(filterCode, event);
        }
    };

    const { debouncedValue: debouncedQuery, setDebouncedValue: setDebouncedQuery } = useDebounce(query, 300);

    const handleSearch = event => {
        setQuery(event.target.value);
    };

    useEffect(() => {
        onSearchChange(debouncedQuery);
    }, [debouncedQuery]);

    return (
        <div className="history-tab__header">
            {/* <ClickOutSideHolder onClickOutside={() => setIsDropdownOpen(false)}> */}
            <div
                className="history-tab__filter-dropdown"
                onClick={toggleDropdown}
                ref={dropdownRef}
                role="button"
                aria-haspopup="listbox"
                aria-expanded={isDropdownOpen}
                tabIndex={0}
            >
                <div
                    className={cx("filter-dropdown__selected", {
                        "filter-dropdown__selected--open": isDropdownOpen,
                    })}
                >
                    {filters.length > 0 ? filters.find(f => f.code === selectedFilter)?.label : t("dontSelect")}
                    <ReactSVG className="filter-dropdown__icon" src={`/data/svg/chevron_down.svg`} />
                </div>
                {isDropdownOpen && (
                    <SmartPortal
                        portalClassName="history-tab-filter-portal-dropdown"
                        targetElement={dropdownRef && dropdownRef.current}
                        portalPlacement="bottom inner-left"
                        portalKey="history-tab-filter-portal-dropdown"
                        onClickOutside={() => setIsDropdownOpen(false)}
                        outerOffset={4}
                    >
                        <div className="filter-dropdown__options" role="listbox">
                            {filters.map(filter => (
                                <div
                                    key={filter.code}
                                    className={`filter-dropdown__option ${
                                        filter.code === selectedFilter ? "selected" : ""
                                    }`}
                                    onClick={e => handleFilterSelect(filter.code, e)}
                                    role="option"
                                    aria-selected={filter.code === selectedFilter}
                                    tabIndex={0}
                                >
                                    {filter.label}
                                </div>
                            ))}
                        </div>
                    </SmartPortal>
                )}
            </div>
            {/* </ClickOutSideHolder> */}
            <div className="history-tab__right-options">
                <div className="history-tab__search">
                    <input
                        type="text"
                        className="search-input"
                        placeholder={t("Search")}
                        onChange={handleSearch}
                        autoFocus
                    />
                    <ReactSVG className="search-icon" src={`/data/svg/search.svg`} />
                </div>
                {/* <button
                    type="button"
                    className="history-tab__refresh-button"
                    onClick={onRefresh}
                    aria-label="Refresh History"
                >
                    <ReactSVG className="refresh-icon" src="/data/svg/grid/refresh.svg" />
                </button> */}
            </div>
            {/* <div className="searchInputWrapper tab-search-wrapper">
                <input
                    type="text"
                    className="searchInput"
                    placeholder={t("Search")}
                    onChange={handleSearch}
                    autoFocus
                />
                <i className="icon-search2" />
            </div> */}
        </div>
    );
};

export default HistoryHeader;
